// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__CbKG8","modal":"Modal_modal__PXCPe"};